import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'

const id = 'EnbridgePipeline'
const authId = 'Pipeline'
const sourceLayer = 'EnbridgePipeline'
// const URL = () => `https://coresight-vector.s3-us-west-2.amazonaws.com/PipelineMask/{z}/{x}/{y}`
const URL = () => `https://coresight-vector.s3-us-west-2.amazonaws.com/EnbridgePipeline/EnbridgePipeline.json`
const transmissionId = 'bridgeBuffer'
const transmissionSourceLayer = 'EnbridgeBuffer'
const BUFFER_URL = () => `https://coresight-vector.s3-us-west-2.amazonaws.com/EnbridgeBuffer/EnbridgeBuffer.json`

export class BriggsIceDepth extends Component {
  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mousemove', id, this.handleMouseMove)
  }

  handleMouseMove = event => {
    return null
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return null
    }
    const features = map.queryRenderedFeatures(undefined, {
      layers: [id]
    })
    const data = features.map(feature => feature.properties)
    console.log(data)
    // actions.dataUpdated(data)
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'geojson',
      data: URL(),
    }
    const bufferSource = {
      type: 'geojson',
      data: BUFFER_URL()
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Source id={transmissionId} tileJsonSource={bufferSource} />
        <Layer
          type='line'
          id={id}
          sourceId={id}
          paint={{
            'line-color': 'green',
            'line-width': 4
          }}
          />
        <Layer
          type='fill'
          id={transmissionId}
          sourceId={transmissionId}
          paint={{
            'fill-opacity': 0.1,
            'fill-color': 'blue',
            'fill-outline-color': 'white'
          }}
          />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times.WaterLakeTss || undefined,
      datetime: getDatetime(state, id) || ''
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(BriggsIceDepth)



// WEBPACK FOOTER //
// ./src/layers/EnbridgePipeline.js